import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

const GET_ONBOARDING_UPLOADED_DOCUMENTS = gql`
    query OnboardingUploadedDocuments($candidateUuid: ID!) {
        onboardingUploadedDocuments(candidateUuid: $candidateUuid) {
            uuid
            filename
            documentType
        }
    }
`;

const useOnboardingUploadedDocuments = (candidateUuid) => {
    const { loading, error, data, refetch } = useQuery(GET_ONBOARDING_UPLOADED_DOCUMENTS, {
        variables: { candidateUuid },
        skip: !candidateUuid,
        fetchPolicy: 'network-only',
    });

    return {
        data: data?.onboardingUploadedDocuments || [],
        loading,
        error,
        refetch,
    };
};

export default useOnboardingUploadedDocuments;
